import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
type Tomo = {
  number: string;
  title: string;
  subtitle: string;
  bullets: string[];
  result: string;
  popular?: boolean;
};
const tomos: Tomo[] = [{
  number: 'Tomo 1',
  title: 'Orígenes y Culturas',
  subtitle: 'La base que tus alumnos necesitan para entender cómo comenzó todo',
  bullets: ['Origen del ser humano, prehistoria y primeras civilizaciones', 'Mesopotamia, Egipto, Grecia, Roma y las culturas americanas', 'Organización social, escritura, religión y legados culturales'],
  result: 'Tus alumnos comprenden cómo surgieron las primeras sociedades y por qué importan hoy.'
}, {
  number: 'Tomo 2',
  title: 'Conquista y Colonia',
  subtitle: 'El encuentro entre mundos que cambió la historia para siempre',
  bullets: ['Expansión europea, llegada a América y organización colonial', 'Economía colonial, encomienda, mita y esclavitud africana', 'Resistencia indígena y consecuencias del proceso de conquista'],
  result: 'Tus alumnos entienden las causas y consecuencias del proceso colonial con profundidad y sentido crítico.'
}, {
  number: 'Tomo 3',
  title: 'Independencia',
  subtitle: 'Los movimientos que transformaron el mapa político de América',
  bullets: ['Ilustración, liberalismo y crisis del sistema colonial', 'Campañas militares, liderazgos y participación popular', 'Formación de nuevos Estados y proyectos políticos'],
  result: 'Tus alumnos comprenden los procesos independentistas como transformaciones profundas, no como fechas aisladas.'
}, {
  number: 'Tomo 4',
  title: 'Siglo XIX',
  subtitle: 'La construcción de los Estados nacionales y las grandes transformaciones del siglo',
  bullets: ['Caudillismo, constituciones, liberalismo y conservadurismo', 'Inmigración, ferrocarril, modernización e industrialización', 'Construcción de identidades nacionales y movimiento obrero'],
  result: 'Tus alumnos entienden cómo se formaron los países y qué fuerzas los transformaron durante el siglo XIX.'
}, {
  number: 'Tomo 5',
  title: 'Siglo XX',
  subtitle: 'El siglo más complejo y el que más preguntas genera en el aula',
  bullets: ['Guerras mundiales, Holocausto, totalitarismos y Guerra Fría', 'Dictaduras, democracias, movimientos sociales y derechos civiles', 'América Latina en el siglo XX: revoluciones, golpes y transformaciones'],
  result: 'Tus alumnos conectan los grandes conflictos del siglo XX con el mundo en que viven hoy.',
  popular: true
}, {
  number: 'Tomo 6',
  title: 'Procesos Contemporáneos',
  subtitle: 'La historia que explica el presente',
  bullets: ['Globalización, migraciones, derechos humanos y memoria histórica', 'Tecnología, redes sociales, desinformación y transformaciones del trabajo', 'Cambio climático, crisis sanitarias y desafíos del mundo actual'],
  result: 'Tus alumnos entienden por qué el mundo es como es y qué tiene que ver la historia con lo que ven todos los días.'
}, {
  number: 'Tomo 7',
  title: 'Fuentes Históricas',
  subtitle: 'El tomo que enseña a pensar como historiador',
  bullets: ['Fuentes primarias y secundarias: escritas, visuales, orales y digitales', 'Autoría, contexto, intencionalidad, sesgos y credibilidad', 'Comparación de fuentes y construcción de explicaciones históricas'],
  result: 'Tus alumnos no solo saben qué pasó: saben cómo se sabe, cómo se interpreta y cómo se argumenta.'
}, {
  number: 'Tomo 8',
  title: 'Actividades y Evaluaciones',
  subtitle: 'La caja de herramientas completa para el aula',
  bullets: ['Más de 30 tipos de actividades listas para aplicar desde hoy', 'Evaluaciones diagnósticas, formativas, integradoras y de cierre', 'Rúbricas, listas de cotejo, criterios de corrección y respuestas orientativas'],
  result: 'Nunca más armas una evaluación desde cero ni bajo presión. Todo está listo.'
}];
export function TomosSection() {
  return <section className="bg-white px-4 py-20" data-id="element-204" data-mp="3hjyp049qnf4n">
      <div className="mx-auto max-w-6xl" data-id="element-205" data-mp="3mgysc7f7e3s2">
        <header className="mb-14 text-center" data-id="element-206" data-mp="3mem2z9748r4z">
          <h2 className="font-serif text-4xl font-bold text-navy" data-id="element-207" data-mp="3rgl8aomf1y4k">
            Los 8 Tomos del Mega Pack
          </h2>
          <p className="mt-3 text-gold-dark" data-id="element-208" data-mp="87dbxd4uk38">Material completo para el aula</p>
        </header>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-209" data-mp="51a11ov8azbi">
          {tomos.map((tomo, i) => <motion.article initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} key={tomo.number} className={`relative flex flex-col overflow-hidden rounded-2xl border bg-white p-7 shadow-[0_6px_18px_rgba(16,42,67,.06)] ${tomo.popular ? 'border-gold/50' : 'border-slate-100'}`} data-id="element-210" data-mp="90r4kcr3hme1" data-mpi={i}>
              {tomo.popular && <span className="absolute right-0 top-0 rounded-bl-xl bg-[#F4E6C3] px-4 py-1 text-xs font-bold text-gold-dark" data-id="element-211" data-mp="f68izvi1xov5">
                  MÁS POPULAR
                </span>}
              <span className="text-sm font-bold uppercase tracking-wider text-gold-dark" data-id="element-212" data-mp="16xemmlwze4p6">
                {tomo.number}
              </span>
              <h3 className="mt-2 font-serif text-2xl font-bold text-navy" data-id="element-213" data-mp="y3jfx9g7o67f">
                {tomo.title}
              </h3>
              <p className="mt-4 border-l-2 border-gold/60 pl-4 text-sm font-medium italic text-ink" data-id="element-214" data-mp="1ulxrsskqi1d1">
                {tomo.subtitle}
              </p>
              <p className="mt-5 text-sm leading-relaxed text-slate-600" data-id="element-215" data-mp="3k21ibhj9qrgl">
                Material práctico, ordenado y explicado para que puedas
                enseñarlo sin adaptar todo desde cero.
              </p>
              <ul className="my-6 flex-grow space-y-2" data-id="element-216" data-mp="3acrq81ofd8sh">
                {tomo.bullets.map(bullet => <li className="flex gap-2 text-sm text-ink" key={bullet} data-id="element-217" data-mp="3fataur1i1g62">
                    <CheckCircle2 size={16} className="mt-0.5 shrink-0 text-green" data-id="element-218" data-mp="31bjt3mxnadzz" />
                    {bullet}
                  </li>)}
              </ul>
              <div className="rounded-xl bg-[#F8F5ED] p-4 text-sm text-ink" data-id="element-219" data-mp="2refdy727viso">
                <strong className="block text-gold-dark" data-id="element-220" data-mp="2wbxdj6ucglo0">Resultado:</strong>
                {tomo.result}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}